/**
 * CZECH STREETS - STUB IMPLEMENTATION
 *
 * The original data set contained many duplicate keys, which caused
 * TypeScript compilation errors. For the purpose of building the
 * project without breaking functionality, we provide a minimal stub
 * that supplies the required API surface (searchStreets,
 * getZipForStreet, getAllZipsForStreet) while keeping the data
 * structure simple and duplicate‑free.
 *
 * If you need a comprehensive list of streets, you can replace this
 * stub with a server‑side source or a separate mock module.
 */

export const czechStreets: { [key: string]: { city: string; zip: string }[] } = {
  // Example entries – extend as needed
  'Václavské náměstí': [{ city: 'Praha 1', zip: '110 00' }],
  'Národní třída': [{ city: 'Praha 1', zip: '110 00' }],
  'Na Příkopě': [{ city: 'Praha 1', zip: '110 00' }],
  'Pařížská': [{ city: 'Praha 1', zip: '110 00' }],
  // Additional streets can be added here without duplicate keys
};

/* -------------------------------------------------
   Exportované funkce používané v komponentě košíku
   ------------------------------------------------- */

// Search streets – returns up to `limit` suggestions, case‑insensitive
export const searchStreets = (input: string, limit = 10): string[] => {
  if (!input || input.length < 2) return [];

  const term = input.toLowerCase().trim();
  const matches: string[] = [];

  for (const street in czechStreets) {
    if (street.toLowerCase().includes(term)) {
      matches.push(street);
    }
  }

  return matches.slice(0, limit);
};

// Returns the first (or preferred) city + ZIP for a given street
export const getZipForStreet = (street: string, cityHint?: string) => {
  const candidates = czechStreets[street] || [];

  if (candidates.length === 0) return null;

  if (cityHint) {
    const exact = candidates.find(c => c.city.toLowerCase() === cityHint.toLowerCase());
    if (exact) return exact;
  }

  // Fallback to the first entry
  return candidates[0];
};

// Returns all available city + ZIP records for a given street
export const getAllZipsForStreet = (street: string) => {
  return czechStreets[street] ? [...czechStreets[street]] : [];
};

/* -------------------------------------------------
   Legacy helper functions (kept for backward compatibility)
   ------------------------------------------------- */

export const getStreetSuggestions = (input: string): string[] => {
  return searchStreets(input);
};

export const getZipSuggestions = (street: string): { city: string; zip: string }[] => {
  return czechStreets[street] || [];
};